export default __webpack_public_path__ + "static/media/qmenta-platform.2125cc7f.svg";